Apt.fn.make('directory', {
	/**
	 * Initialize module
	 */
	init() {
		const scope = this;
		const priv = scope.$private;
		const uri = $.routes.uri();
		const type = uri.segments[0];

		const navigate = type !== priv.type ||
			uri.path !== priv.path;

		priv.path = uri.path;
		priv.type = type;

		if (priv.index) {
			if (navigate) {
				priv.refresh();
			}

			return;
		}

		priv.control();

		priv.initApp();

		priv.meta = Apt.fn.meta()
			.init();

		scope.prefetch();
	},

	/**
	 * Evaluate preload logic
	 */
	preload() {
		if (! this.$private.index) {
			return;
		}

		if (Apt.panel.opened()) {
			Apt.panel.hide();
		}

		const pending = $.history.pending();

		if (! pending || ! pending.action || ! pending.run) {
			return;
		}

		pending.action = false;
	},

	/**
	 * Prefetch profile assets
	 */
	prefetch() {
		const path = '/assets/modules/profile@' + $.get('versions.profile') + '/';

		LS.util.prefetch([
			path + 'style.min.css',
			path + 'script.min.js'
		]);
	},

	/**
	 * Unload module
	 */
	unload() {
		const priv = this.$private;

		if (! priv.type || Apt.panel.opened()) {
			return;
		}

		delete priv.type;

		LS.util.reset('directory', priv, [
			'fallback',
			'index',
			'locator',
			'meta',
			'relevant'
		]);
	}
}, {
	/**
	 * Fetch profiles from server
	 *
	 * @param {String} type
	 * @param {Object} options
	 * @param {Function} fn
	 */
	fetch(type, options, fn) {
		Apt.index.request({
			resource: 'profiles',
			filters: Object.assign({
				limit: 18,
				sort: '-promoted',
				type: type
			}, options)
		}, fn);
	},

	/**
	 * Purge all bound events
	 */
	unbind() {
		LS.util.reset('directory');
	},

	/**
	 * Update index controls
	 */
	control() {
		const scope = this;
		const filters = LS.filters.get();
		const loc = $.context('location');
		const $expand = $$('directoryExpand');

		if (scope.locator) {
			scope.locator.set(loc);
		} else {
			scope.locator = Apt.fn.locator()
				.init('$directoryLocation', {
					value: loc,
					fetch: true,
					changed: () => {
						scope.index.submit();
					}
				});
		}

		$$('directoryGroup').filter('[value="' + (filters.parent || '') + '"]')
			.prop('checked', true);

		$$('specialties').val(filters.specialty || '');
		$$('directoryKeywords').val(filters.keywords || '');

		$expand.on('mousedown', () => {
			$$('directoryFilters').addClass('-is-expanded');
		}, {
			namespace: 'directory',
			once: true
		});

		if (
			filters.parent ||
			filters.keywords
		) {
			$expand.trigger('mousedown');
		}
	}
});